{
  "checkedInTitle": "Vous êtes enregistré",
  "postCheckInInstructions": "Instructions post-enregistrement",
  "appointmentDetails": "Détails du rendez-vous",
  "notifyWarehouse": "Nous avons informé l'entrepôt de votre arrivée afin qu'il puisse vérifier sa disponibilité",
  "waitForStaff": "Veuillez attendre les instructions du personnel de l'entrepôt",
  "unplannedDescription": "Il semble que vous n'ayez pas de rendez-vous. Veuillez attendre les instructions du personnel de l'entrepôt.",
  "whatsappDelay": "Le premier message WhatsApp peut prendre jusqu'à une minute pour arriver.",
  "bookNextTitle": "Réserver un rendez-vous pour la prochaine fois",
  "bookNextBody": "Inscrivez-vous sur Opendock pour réserver un rendez-vous la prochaine fois que vous viendrez à cet établissement",
  "helpFooter": "Si vous avez besoin d'aide ou d'informations supplémentaires, veuillez contacter le personnel de l'entrepôt",
  "finalize": "Finaliser ({seconds})"
}
